import { render, staticRenderFns } from "./toolProperties.vue?vue&type=template&id=5a7fa2c4&lang=pug&"
import script from "./toolProperties.vue?vue&type=script&lang=js&"
export * from "./toolProperties.vue?vue&type=script&lang=js&"
import style0 from "./toolProperties.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports